export default {"src":"/_next/static/media/logo-full.fab917fa.svg","height":97,"width":329,"blurWidth":0,"blurHeight":0};